import React from 'react'

const RoundOne = () => {
  return (
    <div className="w-96 h-96 relative top-0 -left-10 animate-spin-slow">
        <div className="w-32 h-32 rounded-full bg-designColor absolute top-0 blur-xl">
        <div className="w-28 h-28 rounded-full bg-yellow  absolute -bottom-[10rem] left-[20rem] blur-xl">
        <div className="w-24 h-24 rounded-full bg-green-500  absolute top-[9rem] right-[17rem] blur-xl">
            
        </div>    
        </div>
        </div>
    </div>
  )
}

export default RoundOne
